module.exports = __webpack_public_path__ + "static/img/Moses-Mbye.529ef77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Moses-Mbye.jpg
// module id = 36Wy
// module chunks = 0